import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/api';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!password) {
      setError('Please enter the admin password');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await api.post('/users/AdminLogin', { password }, { withCredentials: true });
      
      if (response.status === 200) {
        navigate("/admin");
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Authentication failed');
      setPassword('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#eff1f3] px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="px-4 sm:px-8 pt-6 pb-4 text-center">
          <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">Admin Login</h2>
          <p className="mt-2 text-xs sm:text-sm text-gray-600">
            Secure access for authorized personnel
          </p>
        </div>

        <div className="px-4 sm:px-8 pb-6">
          <div className="space-y-6">
            <div>
              <label 
                htmlFor="admin-password" 
                className="block text-xs sm:text-sm text-gray-700 mb-2"
              >
                Administrator Password
              </label>
              <input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full py-2 px-3 text-sm border rounded-lg 
                          border-[#a9b9e3] text-gray-900
                          focus:border-[#6f48e5] focus:ring-2 focus:ring-[#6f48e5] focus:outline-none
                          transition-all duration-200"
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="rounded-md bg-red-50 p-4 border border-red-200 mb-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-red-800">{error}</p>
                  </div>
                </div>
              </div>
            )}
            
            <button
              onClick={handleLogin}
              disabled={isLoading}
              className="w-full py-2 px-4 bg-[#6f48e5] hover:bg-[#5a3ac4] text-white 
                        text-sm font-medium rounded-lg transition-colors duration-200 
                        disabled:bg-[#a9b9e3] disabled:cursor-not-allowed 
                        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#6f48e5]"
            >
              {isLoading ? 'Authenticating...' : 'Secure Login'}
            </button>
          </div>

          <div className="mt-4 text-center">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} Admin Access Control
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;